<header class="page-header mb-10">
	<h2>Checklists</h2>
</header>

<div class="flex items-center justify-between">
	<div class="flex items-center gap-4">
		<p class="text-lg font-bold">Templates</p>
		<app-button [icon]="ICON.ADD" (click)="addTemplate()">Add new</app-button>
	</div>
	<div class="flex items-center gap-8">
		<div>
			<app-dropdown
				labelOrientation="row"
				label="Sort by"
				[ngModel]="selectedSortOptionName | async"
				(onSelect)="sortDropdownSelected($event)"
				[itemGroups]="[{ items: sortDropdownOptions }]"
			></app-dropdown>
		</div>
		<div class="flex items-center gap-2">
			<app-pill
				class="cursor-pointer"
				[mode]="selectedFileType === 'all' ? 'activeStatus' : 'inactiveStatus'"
				(click)="fileTypeSelected('all')"
				>All</app-pill
			>
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === matterFileType.SALE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="fileTypeSelected(matterFileType.SALE)"
				>Sale</app-pill
			>
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === matterFileType.PURCHASE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="fileTypeSelected(matterFileType.PURCHASE)"
				>Purchase</app-pill
			>
			<app-pill
				class="cursor-pointer"
				[mode]="
					selectedFileType === matterFileType.REFINANCE
						? 'activeStatus'
						: 'inactiveStatus'
				"
				(click)="fileTypeSelected(matterFileType.REFINANCE)"
				>Refinance</app-pill
			>
		</div>
	</div>
</div>

<div class="mt-6 grid grid-cols-4 gap-4">
	<div *ngFor="let checklist of sortedChecklists$ | async">
		<app-checklist-container
			[checklist]="checklist"
			[selectedTemplateId]="selectedTemplateId"
		></app-checklist-container>
	</div>
</div>

<div
	*ngIf="!(customTemplateExists$ | async)"
	class="w-full h-full flex flex-col justify-center items-center mt-40"
>
	<img
		class="empty-checklist-image"
		src="../../../../assets/images/empty-states/checklist.svg"
	/>
</div>
